import React, { useEffect, useState } from "react";
import { Row, Col, Card, Image, Modal, Button, Form } from "react-bootstrap";
import countries from "./countries.json";
const BusinessDetails = ({ initialData, onUpdate }) => {
  const [showModal, setShowModal] = useState(false);
  const [businessData, setBusinessData] = useState({
    name: "",
    website: "",
    address: "",
    country: "",
    overview: "",
  });

  useEffect(() => {
    if (initialData) {
      setBusinessData({
        name: initialData[0] || "",
        website: initialData[1] || "",
        address: initialData[2] || "",
        country: initialData[3] || "",
        overview: initialData[4] || "",
      });
    }
  }, [initialData]);

  const handleEditClick = () => {
    setShowModal(true);
  };

  const handleSave = () => {
    setShowModal(false);
    onUpdate(businessData);
  };

  return (
    <>
      <Row className="px-4 body-font">
        <Col>
          <Card className="business_details_border">
            <Card.Header className="px-4 body-font fw-bold fs-two d-flex justify-content-between business_info_card_header">
              <div className="d-flex black-color" style={{ gap: "12px" }}>
                <Image src="/assets/business-card.svg" alt="Business Details" />
                Business Details
              </div>
              <div
                className="d-flex gap-1 align-items-center cursor-pointer"
                onClick={handleEditClick}
              >
                <Image
                  src="/assets/edit-1.svg"
                  alt="Edit"
                  className="business-info-icon"
                />
                <span className="fs-four" style={{ color: "#5925DC" }}>
                  Edit
                </span>
              </div>
            </Card.Header>

            <Card.Body className="p-4 d-flex flex-column gap-4 black-color">
              <div
                className="d-flex flex-column black-color"
                style={{ gap: "14px" }}
              >
                <p className="mb-0 fw-medium fs-four">Name</p>
                <p className="mb-0 fs-6 fw-normal">
                  {businessData.name || "N/A"}
                </p>
              </div>

              <div
                className="d-flex flex-column black-color"
                style={{ gap: "14px" }}
              >
                <p className="mb-0 fw-medium fs-four">Business Website</p>
                <p className="mb-0 fs-6 fw-normal">
                  <Image
                    src="/assets/globe-gray.svg"
                    alt="Website"
                    style={{ width: "20px", height: "20px" }}
                    className="me-2"
                  />
                  {businessData.website || "N/A"}
                </p>
              </div>

              <div
                className="d-flex flex-column black-color"
                style={{ gap: "14px" }}
              >
                <p className="mb-0 fw-medium fs-four">Address</p>
                <p className="mb-0 fs-6 fw-normal">
                  <Image
                    src="/assets/map-pin-gray.svg"
                    alt="Address"
                    style={{ width: "20px", height: "20px" }}
                    className="me-2"
                  />
                  {businessData.address || "N/A"}
                </p>
              </div>

              <div
                className="d-flex flex-column black-color"
                style={{ gap: "14px" }}
              >
                <p className="mb-0 fw-medium fs-four">Country</p>
                <p className="mb-0 fs-6 fw-normal">
                  {businessData.country || "N/A"}
                </p>
              </div>

              <div
                className="d-flex flex-column black-color"
                style={{ gap: "14px" }}
              >
                <p className="mb-0 fw-medium fs-four">Business Overview</p>
                <p className="mb-0 fs-6 fw-normal">
                  {businessData.overview || "N/A"}
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Modal for Editing */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header
          closeButton
          className="business-hrs-border-bottom"
          style={{ backgroundColor: "#FAFAFA" }}
        >
          <Modal.Title className="fw-medium black-color fs-five">
            Business Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="direction-modal-body">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label
                className="fs-four fw-medium"
                style={{ color: "#414651", marginBottom: "6px" }}
              >
                Business Name
              </Form.Label>

              <Form.Control
                type="text"
                value={businessData.name}
                onChange={(e) =>
                  setBusinessData({ ...businessData, name: e.target.value })
                }
                className="black-color fs-6 fw-normal rounded-3"
                style={{ borderColor: "#D5D7DA", padding: "9px 14px" }}
                placeholder="Business Name"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label
                className="fs-four fw-medium"
                style={{ color: "#414651", marginBottom: "6px" }}
              >
                Business Website
              </Form.Label>
              <div className="position-relative">
                <Form.Control
                  type="text"
                  value={businessData.website}
                  onChange={(e) =>
                    setBusinessData({
                      ...businessData,
                      website: e.target.value,
                    })
                  }
                  className="black-color fs-6 fw-normal rounded-3"
                  style={{
                    borderColor: "#D5D7DA",
                    padding: "9px 14px 9px 42px",
                  }}
                  placeholder="Business Website"
                />
                <Image
                  src="/assets/globe-gray.svg"
                  alt="Website"
                  className="position-absolute"
                  style={{
                    left: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label
                className="fs-four fw-medium"
                style={{ color: "#414651", marginBottom: "6px" }}
              >
                Address
              </Form.Label>
              <div className="position-relative">
                <Form.Control
                  type="text"
                  value={businessData.address}
                  onChange={(e) =>
                    setBusinessData({
                      ...businessData,
                      address: e.target.value,
                    })
                  }
                  className="black-color fs-6 fw-normal rounded-3"
                  style={{
                    borderColor: "#D5D7DA",
                    padding: "9px 14px 9px 42px",
                  }}
                  placeholder="Address"
                />
                <Image
                  src="/assets/map-pin-gray.svg"
                  alt="Website"
                  className="position-absolute"
                  style={{
                    left: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label
                className="fs-four fw-medium"
                style={{ color: "#414651", marginBottom: "6px" }}
              >
                Country{" "}
              </Form.Label>
              <Form.Select
                value={businessData.country}
                onChange={(e) =>
                  setBusinessData({ ...businessData, country: e.target.value })
                }
                className={`fs-6 fw-normal rounded-3 ${
                  !businessData.country ? "gray-color italic" : "black-color "
                }`}
                style={{ borderColor: "#D5D7DA", padding: "9px 14px" }}
              >
                <option value="" style={{ color: "gray-color" }}>
                  Select Country
                </option>
                {countries.map((country) => (
                  <option key={country.country_id} value={country.country_name}>
                    {country.country_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label
                className="fs-four fw-medium"
                style={{ color: "#414651", marginBottom: "6px" }}
              >
                Business Overview
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={businessData.overview}
                onChange={(e) =>
                  setBusinessData({ ...businessData, overview: e.target.value })
                }
                className="black-color fs-6 fw-normal rounded-3"
                style={{ borderColor: "#D5D7DA", padding: "9px 14px" }}
                placeholder="Enter a description..."
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="gap-4 business-info-modal-footer">
          <span className="gray-color fs-four m-0">
            Changes will go live immediately
          </span>
          <div className="gap-3 m-0 d-flex">
            <Button
              className="m-0 direction-modal-button fw-bold fs-four border-0 direction-modal-cancel"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="direction-modal-button m-0 btn-primary-style fw-bold px-3 fs-four"
              style={{ color: "#ffffff" }}
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BusinessDetails;
